import { isAiTravel } from '@this/src/util/utils';

type Platform = 'ios' | 'android' | 'other';

declare const serviceId: number | undefined;
declare const appBannerOnelinkUrl: string | undefined;

export const getServiceId = (): number | undefined => {
  if (typeof serviceId === 'undefined') return undefined;
  return serviceId;
};

export const getAppBannerOnelinkUrl = (): string | undefined => {
  if (typeof appBannerOnelinkUrl === 'undefined') return undefined;
  return appBannerOnelinkUrl;
};

export const getDeviceInfo = () => {
  if (typeof navigator === 'undefined') {
    return { platform: 'other' as Platform, isIOS: false, isAndroid: false, isSafari: false, isMobile: false };
  }

  const ua = navigator.userAgent;

  const isIOS = /iPhone|iPad|iPod/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  const isAndroid = /Android/.test(ua);
  const isSafari = /Safari/.test(ua) && !/Chrome/.test(ua) && !/CriOS/.test(ua) && !/FxiOS/.test(ua);
  const isMobile = /iPhone|iPod|Android.*Mobile/.test(ua);

  let platform: Platform = 'other';
  if (isIOS) platform = 'ios';
  else if (isAndroid) platform = 'android';

  return {
    platform,
    isIOS,
    isAndroid,
    isSafari,
    isMobile
  };
};

export const shouldShowCustomBanner = (): boolean => {
  const currentServiceId = getServiceId();
  if (currentServiceId === undefined || !isAiTravel(currentServiceId)) return false;

  const { isIOS, isAndroid, isSafari, isMobile } = getDeviceInfo();

  if (!isMobile) return false;
  if (isIOS && isSafari) return false;

  return isIOS || isAndroid;
};
